export default {"src":"/_next/static/media/postgresql.eeb3d602.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};